import { memo } from 'react';
import AddUserPopup from './AddUserPopup';
import { ExtraProps } from '../../popup/ButtonPopup/ButtonPopup';

const AddUserPopupAdapter: React.FC<{
  open: boolean;
  onClose: () => void;
  extra?: ExtraProps;
}> = ({ open, onClose, extra }) => {
  return <AddUserPopup open={open} onCancel={onClose} extra={extra} />;
};

export default memo(AddUserPopupAdapter);
